module.exports = __webpack_public_path__ + "img/no-data-export-excel.2a91627f.svg";